"use client";

import Link from "next/link";
import { AiOutlineHome } from "react-icons/ai";
import { menuItems } from "@/utils/constants";
import LanguageSwitcher from "../Comman/LanguageSwitcher";
import ThemeSwitcher from "../Comman/ThemeSwitcher";
import { usePathname } from "next/navigation";

const DesktopNav = () => {
  const pathname = usePathname();

  return (
    <nav className="container h-full hidden lg:flex items-center justify-between">
      <menu className="flex items-center gap-6">
        <li className="shrink-0 mr-4">
          <Link title="Home" href="/" className="flex items-center gap-2">
            <AiOutlineHome className="text-primary text-xl" />
          </Link>
        </li>

        {menuItems?.map((item: any, index: number) => (
          <li key={index} className="hover:text-primary text-text1 relative">
            {item.isNew && (
              <span className="absolute -top-3.5 left-1/2 -translate-x-1/2 bg-primary text-[8px] px-1 rounded-sm text-white font-bold whitespace-nowrap">
                NEW
              </span>
            )}
            <Link className="text-sm" href={item.href}>
              {item.title}
            </Link>
          </li>
        ))}
      </menu>

      <div className="flex items-center gap-4">
        <LanguageSwitcher />

        <Link
          href="https://baghpartners.com/page/affiliate/login.jsp"
          target="_blank"
          rel="noopener noreferrer nofollow"
          className="btn text-base/6 font-bold text-text1 w-[200px] h-[38px] rounded-full bg-primary flex items-center justify-center hover:bg-white hover:text-primary transition-all border border-transparent hover:border-primary relative overflow-hidden"
          title="Login/Register"
        >
          Login/Register
          <span className="shine-effect shine-orange" aria-hidden="true"></span>
        </Link>

        <ThemeSwitcher />
      </div>
    </nav>
  );
};

export default DesktopNav;
